import { IValidationPortabilityMobile } from '@vfit/consumer/data-access';
import * as yup from 'yup';

export const portabilityNumberSchema = (validationMessage?: IValidationPortabilityMobile) =>
  yup.object({
    phoneNumber: yup
      .string()
      .required(validationMessage?.phoneNumber?.required || '')
      .min(9, validationMessage?.phoneNumber?.minimum || ' ')
      .max(11, validationMessage?.phoneNumber?.maximum || ' ')
      .matches(/^(3)+[0-9]*$/, validationMessage?.phoneNumber?.matches || ''),
  });
